import { render } from "./ScoreboardPhoneticVowel.vue?vue&type=template&id=5588f665&scoped=true"
import script from "./ScoreboardPhoneticVowel.vue?vue&type=script&lang=js"
export * from "./ScoreboardPhoneticVowel.vue?vue&type=script&lang=js"

import "@/css/components/scoreboard-phonetic-vowel.css?vue&type=style&index=0&id=5588f665&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5588f665"]])

export default __exports__